import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { Box, Grid, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import InvoicesTable from "./components/InvoicesTable";

export function Invoices() {
  const navigate = useNavigate();

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12} md={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "1.0rem",
            }}
          >
            <Typography variant="h5">Fakturor</Typography>
            <Button
              onClick={() => navigate("create")}
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
            >
              SKAPA NY
            </Button>
          </Box>
          <InvoicesTable />
        </Grid>
      </Grid>
    </Box>
  );
}
